import React, {Component} from 'react'
import {Card, Table, Button, Modal, Form, Input, notification, Select, Popconfirm, Tree, Spin} from 'antd';
import {
    getWenshuTopicList,
    saveOrUpdateWenshuTopic,
    deleteWenshuTopic,
    getAllWenshuTopics,
    getTopicTables,
    saveTopicTables
} from '../../request'
import * as Icon from '@ant-design/icons';

const { Option } = Select;

let columnsKey = {
    topicId: '主题ID',
    topicName: '主题名称',
    topicCode: '主题编码',
    topicDesc: '主题描述',
    dataPermissionFlag: '涉及数据权限',
    status: '状态',
    actions: '操作'
}

const layout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 18,
    },
};

const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 18,
    },
};

const initItemDetail = {
    topicId: '',
    topicName: '',
    topicCode: '',
    topicDesc: '',
    dataPermissionFlag: 0,
    status: 1
}

export default class sysWenshuTopic extends Component {
    state = {
        formParam: {
            topicName: '',
            currentPage: 1,
            pageSize: 20
        },
        total: 0,
        dataSource: [],
        columns: [],
        loading: false,
        initItemDetail,
        topicModalVisible: false,
        tableModalVisible: false,
        tableTreeData: [],
        tableCheckedKeys: [],
        tableTreeLoading: false,
        tableTargetTopic: null,
    };

    normalizeTopicItem = (item = {}) => {
        const flag = item.dataPermissionFlag;
        const dataPermissionFlag = flag === 1 || flag === '1' || flag === true ? 1 : 0;
        return {...item, dataPermissionFlag};
    }

    createColumns = (createKeys) => {
        let columns = Object.keys(createKeys).map(item => {
            let initObj = {
                title: createKeys[item],
                dataIndex: item,
                key: item,
                align: 'center'
            }
            if (item == 'status') {
                return {
                    ...initObj,
                    render: (text, record, index) => {
                        return text == 1 ? 
                            <Icon.CheckCircleOutlined style={{fontSize: '16px', color: 'green'}}/> : 
                            <Icon.CloseCircleOutlined style={{fontSize: '16px', color: 'red'}}/>
                    }
                }
            } else if (item == 'dataPermissionFlag') {
                return {
                    ...initObj,
                    render: (text) => {
                        const isOn = text == 1 || text === true;
                        return isOn ? '是' : '否';
                    }
                }
            } else if (item == 'actions') {
                return {
                    ...initObj,
                    fixed: 'right',
                    width: 240,
                    render: (text, record, index) => {
                        return (
                            <>
                                <Button type="link" size="small" onClick={() => (this.handleItemEdit(record))}>修改</Button>
                                <Button type="link" size="small" onClick={() => this.handleTableConfig(record)}>库表配置</Button>
                                <Popconfirm
                                    title="确定要删除这个问数主题吗？"
                                    onConfirm={() => this.handleItemDelete(record)}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <Button type="link" size="small" danger>删除</Button>
                                </Popconfirm>
                            </>
                        )
                    }
                }
            } else {
                return initObj
            }
        })
        this.setState({
            columns,
        })
    }

    initTableDataList() {
        this.setState({loading: true});
        let param = {...this.state.formParam}
        getWenshuTopicList({...param}).
        then(res => {
            this.setState({
                loading: false,
                dataSource: (res.list || []).map(this.normalizeTopicItem),
                total: res.total || 0,
            })
        }).catch(err => {
            this.setState({loading: false});
        })
    }

    handleItemEdit = (item) => {
        this.setState({
            topicModalVisible: true,
            initItemDetail: this.normalizeTopicItem(item),
        })
    }

    handleItemDelete = (item) => {
        deleteWenshuTopic({topicId: item.topicId}).then(res => {
            notification.success({
                message: '删除成功',
            });
            this.initTableDataList()
        })
    }

    handleSubmit = (values) => {
        const {initItemDetail} = this.state;
        values.topicId = initItemDetail.topicId
        values.dataPermissionFlag = values.dataPermissionFlag === 1 || values.dataPermissionFlag === true ? 1 : 0;
        saveOrUpdateWenshuTopic({...values}).
        then(async res => {
            notification.success({
                message: '操作成功',
            });
            this.setState({
                topicModalVisible: false,
                initItemDetail,
            })
            this.initTableDataList()
        })
    }

    handleCloseModel = () => {
        this.setState({
            topicModalVisible: false,
        })
    }

    handlePageChange = (pagination) => {
        let param = {...this.state.formParam}
        param.currentPage = pagination.current
        param.pageSize = pagination.pageSize
        this.setState({
            formParam: {...param}
        })
        this.initTableDataList()
    }

    handleSearchSubmit = (values) => {
        let param = {...this.state.formParam}
        this.setState({
            formParam: {...param, ...values, currentPage: 1}
        }, () => {
            this.initTableDataList()
        })
    }

    componentDidMount() {
        this.createColumns(columnsKey);
        this.initTableDataList()
    }

    handleTableConfig = (item) => {
        if (!item.topicId) {
            return;
        }
        this.setState({
            tableModalVisible: true,
            tableTreeData: [],
            tableCheckedKeys: [],
            tableTreeLoading: true,
            tableTargetTopic: item,
        }, () => this.loadTopicTables(item.topicId));
    }

    loadTopicTables = (topicId) => {
        this.setState({tableTreeLoading: true});
        getTopicTables({topicId}).then(res => {
            const allSchemas = res.allSchemas || [];
            const selectedTables = res.selectedTables || [];
            const treeData = allSchemas.map(schema => ({
                title: schema.schema,
                key: `schema:${schema.schema}`,
                schemaName: schema.schema,
                selectable: false,
                checkable: false,
                children: (schema.tables || []).map(t => {
                    const key = `\`${schema.schema}\`.\`${t}\``;
                    return {title: t, key, isLeaf: true};
                })
            }));
            this.setState({
                tableTreeData: treeData,
                tableCheckedKeys: selectedTables,
                tableTreeLoading: false
            })
        }).catch(() => {
            this.setState({tableTreeLoading: false});
        })
    }

    handleTreeCheck = (checkedKeys) => {
        // 只保留表节点（去掉 schema 的 key）
        const keys = Array.isArray(checkedKeys) ? checkedKeys : (checkedKeys.checked || []);
        const pureTables = keys.filter(k => !String(k).startsWith('schema:'));
        this.setState({tableCheckedKeys: pureTables});
    }

    handleTableSubmit = () => {
        const {tableCheckedKeys, tableTargetTopic} = this.state;
        if (!tableTargetTopic) {
            return;
        }
        this.setState({tableTreeLoading: true});
        const tableNames = tableCheckedKeys.join(',');
        saveTopicTables({topicId: tableTargetTopic.topicId, tableNames})
            .then(() => {
                notification.success({message: '库表配置已保存'});
                this.setState({tableModalVisible: false, tableTreeLoading: false});
            })
            .catch(() => {
                this.setState({tableTreeLoading: false});
            });
    }

    handleCloseTableModal = () => {
        this.setState({
            tableModalVisible: false,
            tableTreeData: [],
            tableCheckedKeys: [],
            tableTargetTopic: null,
        })
    }

    getSchemaFromTableKey = (key) => {
        const match = /^`(.+)`\.`(.+)`$/.exec(String(key || ''));
        return match ? match[1] : '';
    }

    getSchemaCheckedCount = (checkedKeys) => {
        const counts = {};
        (checkedKeys || []).forEach(key => {
            const schema = this.getSchemaFromTableKey(key);
            if (schema) {
                counts[schema] = (counts[schema] || 0) + 1;
            }
        });
        return counts;
    }

    renderSchemaTitle = (name, count = 0) => {
        if (count <= 0) {
            return name;
        }
        return (
            <span>
                {name}
                <span style={{color: '#f5222d', marginLeft: 6}}>({count})</span>
            </span>
        )
    }

    buildTreeWithCounts = () => {
        const {tableTreeData, tableCheckedKeys} = this.state;
        const counts = this.getSchemaCheckedCount(tableCheckedKeys);
        const loop = (nodes = []) => nodes.map(node => {
            if (node.children) {
                const schemaName = node.schemaName || node.title;
                return {
                    ...node,
                    title: this.renderSchemaTitle(schemaName, counts[schemaName] || 0),
                    children: loop(node.children)
                }
            }
            return {...node};
        });
        return loop(tableTreeData);
    }

    render() {
        const {dataSource, total, columns, formParam, loading, tableTargetTopic} = this.state;
        return (
            <div>
                <Card title="问数主题管理" bordered={false}>
                    <Form onFinish={this.handleSearchSubmit} layout="inline">
                        <Form.Item label="主题名称" name={'topicName'}>
                            <Input placeholder="请输入主题名称" style={{width: '200px'}}/>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" style={{marginRight: '10px'}} htmlType={'submit'}>查询</Button>
                            <Button type="primary" danger style={{marginBottom: '10px'}}
                                    onClick={() => this.handleItemEdit(initItemDetail)}>新增</Button>
                        </Form.Item>
                    </Form>

                    <Table
                        bordered
                        size="small"
                        pagination={{total: total, current: formParam.currentPage, pageSize: formParam.pageSize}}
                        dataSource={dataSource}
                        columns={columns}
                        rowKey={record => record.topicId}
                        onChange={this.handlePageChange}
                        loading={loading}/>
                </Card>
                <Modal
                    title={this.state.initItemDetail.topicId ? "修改问数主题" : "新增问数主题"}
                    width="570px"
                    open={this.state.topicModalVisible}
                    destroyOnClose={true}
                    onCancel={this.handleCloseModel}
                    footer={null}
                >
                    <Form
                        {...layout}
                        labelAlign="right"
                        preserve={false}
                        initialValues={this.state.initItemDetail}
                        onFinish={this.handleSubmit}
                    >
                        <Form.Item
                            label="主题名称"
                            name="topicName"
                            rules={[{required: true, message: '请输入主题名称'}]}
                        >
                            <Input autoComplete="off"/>
                        </Form.Item>

                        <Form.Item
                            label="主题编码"
                            name="topicCode"
                            rules={[{required: true, message: '请输入主题编码'}]}
                        >
                            <Input autoComplete="off"/>
                        </Form.Item>

                        <Form.Item
                            label="主题描述"
                            name="topicDesc"
                        >
                            <Input.TextArea rows={4} placeholder="请输入主题描述"/>
                        </Form.Item>

                        <Form.Item
                            label="是否涉及数据权限"
                            name="dataPermissionFlag"
                        >
                            <Select style={{width: '100%'}}>
                                <Option value={1}>是</Option>
                                <Option value={0}>否</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="状态"
                            name="status"
                        >
                            <Select style={{width: '100%'}} value={this.state.initItemDetail.status}>
                                <Option value={1}>有效</Option>
                                <Option value={-1}>无效</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item {...tailLayout}>
                            <Button type="primary" htmlType="submit">
                                提交
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    title={tableTargetTopic ? `配置库表 - ${tableTargetTopic.topicName}` : '配置库表'}
                    width="520px"
                    open={this.state.tableModalVisible}
                    destroyOnClose={true}
                    onCancel={this.handleCloseTableModal}
                    onOk={this.handleTableSubmit}
                    confirmLoading={this.state.tableTreeLoading}
                >
                    <Spin spinning={this.state.tableTreeLoading}>
                        <Tree
                            checkable
                            defaultExpandAll
                            checkedKeys={this.state.tableCheckedKeys}
                            treeData={this.buildTreeWithCounts()}
                            onCheck={this.handleTreeCheck}
                        />
                    </Spin>
                </Modal>
            </div>
        )
    }
}
